import React, { Component } from 'react'
import { Label, Row } from 'reactstrap'
import ModalForm from '../../comum/components/ModalForm'
import FormInputSimples from '../../comum/components/FormInputSimples'
import FormSelectSimples from '../../comum/components/FormSelectSimples'
import { IconeCarregar, IconeInformacao } from '../../comum/components/Icones'
import { inject, observer } from 'mobx-react'

@inject("store")
@observer
export default class BloqueioCadastrar extends Component {

    constructor(props){
        super(props)

        this.state = {
            salvando: false
        }

        this.controller = this.props.controller
        this.controller.isEditando ? this.controller.editarDadosBloqueio() : this.controller.cleanNovoBloqueio()
    }

    handleSalvar = () => {
        this.setState({
            salvando: true
        },() => {
            if(!this.alertaNumBl() && !this.alertaNovaOperacao()){
                if(this.controller.isEditando)
                    this.controller.editarBloqueio()
                else
                    this.controller.inserirBloqueio()            }
        })
    }

    alertaNumBl = () => {
        if(this.state.salvando && this.controller.numBlNovo === "") return "Campo obrigatório"
        else return false
    }

    alertaNovaOperacao = () => {
        if(this.state.salvando && !this.controller.operacaoEscolidaNovoBloqueio) return "Campo obrigatório"
        else return false
    }

    render() {
        return (
            <ModalForm
                className="tamanho-modal-cabotagem"
                onClickCancelar={ () => this.controller.hideAdicionarBloqueio() }
                onClickSalvar={ this.handleSalvar }
                labelConfirmar={ this.controller.salvando && <IconeCarregar tamanho="2x" /> }
            >
                <h2>{this.controller.isEditando ? "Editar bloqueio" : "Novo bloqueio"}</h2>
                <Row className="pb-0">
                    <FormInputSimples
                        xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="BL"
                        limiteMaximo={255}
                        obrigatorio={true}
                        dado={this.controller.numBlNovo}
                        onChange={this.controller.onChangeBlNovoBloqueio}
                        alerta={this.alertaNumBl()}
                    />
                    <FormSelectSimples
                        xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Operação"
                        obrigatorio={true}
                        itens={this.controller.operacoes}
                        dado={this.controller.operacaoEscolidaNovoBloqueio}
                        bloqueado={this.controller.operacoes.length === 0}
                        onChange={ (event) => this.controller.onChangeOperacaoNovoBloqueio(event) }
                        alerta={this.alertaNovaOperacao()}
                    />
                </Row>
                {this.controller.mensagemErro !== "" && <Row className="pl-3 pb-0"><Label className="label-danger">{this.controller.mensagemErro}</Label></Row>}
                <Row className="pl-3">
                    <Label>
                        <IconeInformacao className="pr-1" />
                        Insira o número do BL idêntico ao registro no SISCARGA.
                    </Label>
                </Row>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bloqueiobl/components/BloqueioCadastrar.js